import { ReactComponent as CspdclLogo } from "../../icons/Cspdclogo.svg";
export default function CgsHeading({ title }: { title: string }) {
  return (
    <div className="header grid grid-cols-3 items-center">
      <h1 className="col-span-1">{title}</h1>
      <div className="col-span-1 flex flex-row justify-center items-center space-x-2 ">
        <CspdclLogo width={"40px"} height={"60px"} />
        <h1>CSPDCL Power Analytics Center</h1>
      </div>
      <div className="col-span-1"></div>
    </div>
  );
}
export function CgsTitle() {
  return (
    <div className="flex flex-row justify-center items-center space-x-2 ">
      <CspdclLogo width={"60px"} height={"60px"} />
      <h1 className="text-[#6F6D7C] text-[18px] ">
        CSPDCL Power Analytics Center
      </h1>
    </div>
  );
}

interface FooterProps {
  source: string;
  note: string;
}

export const GnaRuvnlFooter: React.FC<FooterProps> = ({ source, note }) => {
  return (
    <div className="gna-footer-container">
      <div className="flex justify-between">
        <p className="gna-footer-text">{source}</p>
        <p className="gna-footer-text col-span-1 text-center">
          Powered by <strong>GNA Energy</strong>
        </p>
        {/* <p className="gna-footer-text">Beta Version</p> */}
      </div>
      <p className="gna-footer-note">{note}</p>
      <p className="gna-footer-note">
        MW = Represents the average (MW) based on the selected time interval
        (Date or Month).
      </p>
    </div>
  );
};
